import { Link } from "react-router-dom";
import { AequiaMark, Button, Icon } from "@/components/ui";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-bg text-text">
      <div className="max-w-[480px] text-center">
        <AequiaMark size={72} />
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-bg-2 text-text-2 my-5">
          <Icon name="alertCirc" size={22} />
        </div>
        <div className="text-[11px] uppercase tracking-eyebrow text-muted font-semibold mb-2">
          Error 404 · Página no encontrada
        </div>
        <h1 className="font-serif text-3xl font-medium tracking-tightish mb-3">
          No encontramos lo que buscabas.
        </h1>
        <p className="text-sm text-text-2 leading-relaxed mb-6">
          La URL puede haber cambiado o la página ya no existe. Revisa el enlace
          o vuelve al inicio.
        </p>
        <div className="flex justify-center gap-2">
          <Link to="/dashboard">
            <Button variant="primary" size="md">Ir al dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
